import React, { useEffect, useState } from "react";

interface ZoneFormProps {
  onSave: (zone: { _id?: string; name: string }) => void;
  initialZone?: { _id?: string; name: string } | null;
  onCancel?: () => void;
}

const ZoneForm: React.FC<ZoneFormProps> = ({ onSave, initialZone, onCancel }) => {
  const [name, setName] = useState("");

  useEffect(() => {
    if (initialZone) {
      setName(initialZone.name);
    }
  }, [initialZone]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave({ _id: initialZone?._id, name });
  };

  return (
    <form onSubmit={handleSubmit} className="p-4 border rounded mt-4 bg-gray-50">
      <div className="mb-2">
        <label className="block">Nom de la zone :</label>
        <input
          className="border p-1 w-full"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </div>

      <button type="submit" className="px-4 py-2 bg-blue-500 text-white rounded mr-2">
        {initialZone ? "Mettre à jour" : "Créer"}
      </button>
      {onCancel && (
        <button
          type="button"
          className="px-4 py-2 bg-gray-400 text-white rounded"
          onClick={onCancel}
        >
          Annuler
        </button>
      )}
    </form>
  );
};

export default ZoneForm;
